if (!customElements.get('cart-item-selection')) {
  customElements.define(
    'cart-item-selection',
    class CartItemSelection extends HTMLElement {
      static uncheckedVariantIds = new Set();

      connectedCallback() {
        this.selectAllCheckbox = this.querySelector('.cart-item__select-all-checkbox');
        this.itemCheckboxes = Array.from(this.querySelectorAll('.cart-item__select-checkbox'));

        this.itemCheckboxes.forEach((checkbox) => {
          if (CartItemSelection.uncheckedVariantIds.has(checkbox.dataset.variantId)) {
            checkbox.checked = false;
          }
          checkbox.addEventListener('change', this.onItemChange.bind(this));
        });

        if (this.selectAllCheckbox) {
          this.selectAllCheckbox.addEventListener('change', this.onSelectAllChange.bind(this));
        }

        this.syncSelectAll();
        this.notifySelectionChange();
      }

      onItemChange(event) {
        event.stopPropagation();
        const { variantId } = event.target.dataset;
        if (event.target.checked) {
          CartItemSelection.uncheckedVariantIds.delete(variantId);
        } else {
          CartItemSelection.uncheckedVariantIds.add(variantId);
        }
        this.syncSelectAll();
        this.notifySelectionChange();
      }

      onSelectAllChange(event) {
        event.stopPropagation();
        const checked = event.target.checked;
        this.itemCheckboxes.forEach((checkbox) => {
          checkbox.checked = checked;
          if (checked) {
            CartItemSelection.uncheckedVariantIds.delete(checkbox.dataset.variantId);
          } else {
            CartItemSelection.uncheckedVariantIds.add(checkbox.dataset.variantId);
          }
        });
        this.notifySelectionChange();
      }

      syncSelectAll() {
        if (!this.selectAllCheckbox || this.itemCheckboxes.length === 0) return;
        const checkedCount = this.itemCheckboxes.filter((checkbox) => checkbox.checked).length;
        this.selectAllCheckbox.checked = checkedCount === this.itemCheckboxes.length;
        this.selectAllCheckbox.indeterminate = checkedCount > 0 && checkedCount < this.itemCheckboxes.length;
      }

      notifySelectionChange() {
        const uncheckedCount = this.itemCheckboxes.filter((checkbox) => !checkbox.checked).length;
        document.dispatchEvent(
          new CustomEvent('cart:selection-change', {
            detail: { hasPartialSelection: uncheckedCount > 0 && uncheckedCount < this.itemCheckboxes.length },
          })
        );
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'eco-vanille:held-cart-items';

  const CONTEXTS = [
    { buttonId: 'checkout', formId: 'cart', errorsId: 'cart-errors', noticeId: 'CartPartialCheckoutNotice' },
    {
      buttonId: 'CartDrawer-Checkout',
      formId: 'CartDrawer-Form',
      errorsId: 'CartDrawer-CartErrors',
      noticeId: 'CartDrawerPartialCheckoutNotice',
    },
  ];

  document.addEventListener('cart:selection-change', function (event) {
    CONTEXTS.forEach((ctx) => {
      const notice = document.getElementById(ctx.noticeId);
      if (notice) notice.hidden = !event.detail.hasPartialSelection;
    });
  });

  document.addEventListener('click', function (event) {
    const ctx = CONTEXTS.find((c) => event.target.closest('#' + c.buttonId));
    if (!ctx) return;

    const checkoutButton = document.getElementById(ctx.buttonId);
    const cartForm = document.getElementById(ctx.formId);
    const errors = document.getElementById(ctx.errorsId);
    if (!checkoutButton || !cartForm) return;

    const checkboxes = Array.from(cartForm.querySelectorAll('.cart-item__select-checkbox'));
    if (checkboxes.length === 0) return;

    const unchecked = checkboxes.filter((checkbox) => !checkbox.checked);
    if (unchecked.length === 0) return;

    event.preventDefault();

    const checked = checkboxes.filter((checkbox) => checkbox.checked);
    if (checked.length === 0) {
      if (errors) errors.textContent = window.cartStrings.selectAtLeastOne;
      return;
    }

    if (errors) errors.textContent = '';
    checkoutButton.setAttribute('disabled', 'disabled');

    const heldItems = unchecked.map((checkbox) => ({
      id: Number(checkbox.dataset.variantId),
      quantity: Number(checkbox.dataset.quantity),
    }));

    const updates = {};
    unchecked.forEach((checkbox) => {
      updates[checkbox.dataset.variantId] = 0;
    });

    fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body: JSON.stringify({ updates }) } })
      .then((response) => response.json())
      .then((cartState) => {
        if (cartState.errors) {
          throw new Error(cartState.errors);
        }
        saveHeldItems(heldItems);
        submitCheckout(cartForm);
      })
      .catch(() => {
        checkoutButton.removeAttribute('disabled');
        if (errors) errors.textContent = window.cartStrings.error;
      });
  });

  function submitCheckout(cartForm) {
    let checkoutInput = cartForm.querySelector('input[name="checkout"]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      cartForm.appendChild(checkoutInput);
    }
    checkoutInput.value = 'Checkout';
    cartForm.submit();
  }

  function saveHeldItems(items) {
    let existing = [];
    try {
      existing = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      existing = [];
    }

    items.forEach((item) => {
      const match = existing.find((held) => held.id === item.id);
      if (match) {
        match.quantity += item.quantity;
      } else {
        existing.push(item);
      }
    });

    localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
  }
});
